export default __webpack_public_path__ + "static/membershipHero-72bd105675fa182c718fcc9fb05fe415.jpg";